import { render, staticRenderFns } from "./AiDropdown.vue?vue&type=template&id=36600d51"
import script from "./AiDropdown.vue?vue&type=script&lang=js"
export * from "./AiDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports